import { inject, observer } from 'mobx-react';
import * as React from 'react';
import CookieConsentStore from '../stores/CookieConsentStore';
import RouteStore from '../stores/RouteStore';

interface HasParamProps {
  param: string;
  routeStore?: RouteStore;
  value?: string;
  skipSessionStorage?: boolean;
  children?: React.ReactNode;
}

const DEFAULT_PARAM = 'type';

@observer
class HasParam extends React.Component<HasParamProps, any> {
  constructor(props: HasParamProps) {
    super(props);
    this.state = { isVisible: false };
  }

  public componentDidMount() {
    const isVisible = this.isVisible();
    this.setState({ isVisible });
  }

  private getStorageKey = (param: string) => {
    const { routeStore } = this.props;
    return `${routeStore.pathname}-${param}`;
  };

  private isVisible = () => {
    const { routeStore, param, value, skipSessionStorage } = this.props;
    const requiredParamLower = param ? param.toLowerCase() : DEFAULT_PARAM;
    const requiredValueLower = value?.toLowerCase();
    const urlParamValue = routeStore.decodedParams[requiredParamLower]?.toLowerCase();
    const storageValue = skipSessionStorage ? null : sessionStorage.getItem(this.getStorageKey(requiredParamLower));
    if (!storageValue && !urlParamValue && !value) {
      return true;
    }
    if (storageValue && !value) {
      return false;
    }
    if (storageValue === requiredValueLower || urlParamValue === requiredValueLower) {
      if (CookieConsentStore.isPreferencesCookiesEnabled() && !skipSessionStorage) {
        sessionStorage.setItem(this.getStorageKey(requiredParamLower), value);
      }
      return true;
    }
    return false;
  };

  public render() {
    return this.state.isVisible ? this.props.children : null;
  }
}

export default inject('routeStore')(HasParam);
